import React, { Suspense, useReducer, useEffect, useState } from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import Login from "./containers/Login";
import casLogin from "./containers/casLogin";
import Home from "./containers/Home";
import DevicesGroups from "./containers/DevicesGroups";
import CompanyDevice from "@/containers/CompanyDevice";
import AccessManagement from "./containers/AccessManagement";
import UserManagement from "@/containers/UserManagement";
import GroupsUsers from "./containers/GroupsUsers";
import StoreManagement from "./containers/StoreManagement";
import PermissionManagement from "./containers/PermissionManagement";
import Subscriptions from "./containers/Subscriptions";
import SubscribeNewService from "./containers/SubscribeNewService";
import ServiceManagement from "./containers/ServiceManagement";
import ForgotPassword from "./containers/ForgotPassword.js";
import LoginAgain from "./containers/LoginWithNewPassword";
import AccountCenter from "./containers/AccountCenter";
import CompanyProfile from "./containers/CompanyProfile";
import Announcement from "./containers/Announcement";
import CreateAnnouncement from "./containers/CreateAnnouncement";
import VerifyEmail from "./containers/VerifyEmail";
import PrivateRoute from "./hoc/PrivateRoute";
import GlobalProvider, { useGlobalDispatch } from "./GlobalProvider";
import Auth from "./auths/Auth";
import {
  styledSubmitBtnState,
  styledSubmitBtnReducer
} from "./reducers/styledSubmitBtnReducer";
import NoPermission from "./containers/NoPermission";
import {
  getNotificationState,
  getNotificationReducer
} from "./reducers/getNotificationReducer";
import LoginErrorPage from "./containers/LoginError";
import CommonLayout from "@/layouts/CommonLayout";
// use for recognize the node server and kill it, rather than kill all the node server.
// process.title = "fec-platform";

import { BrowserRouter as Router, Routes, useLocation } from "react-router-dom";
import CreateTerm from "./containers/CreateTerm";
import PersonalizedManagement from "./containers/PersonalizedManagement";
import { LanguageProvider } from "./langs/LanguageProvider";

// 监听路由变化
const RouteChangeDetector = () => {
  const { clearStoreManagementCompany, clearUserManagementCompany } =
    useGlobalDispatch();
  const location = useLocation();
  const [previousLocation, setPreviousLocation] = useState(location);

  useEffect(() => {
    // console.log('Previous route:', previousLocation.pathname);
    // console.log('Current route:', location.pathname);
  }, [location, previousLocation]);

  return null; // 这个组件仅用于监听路由变化，不需要渲染内容
};

export const SubmitBtnContext = React.createContext({}); // context for btn loading animation
export const NotificationContext = React.createContext({});

function App() {
  const [, dispatch] = useReducer(styledSubmitBtnReducer, styledSubmitBtnState);
  const [, getNotiDispatch] = useReducer(
    getNotificationReducer,
    getNotificationState
  );

  return (
    <Suspense fallback="loading">
      <Auth>
        <GlobalProvider>
          <LanguageProvider>
            {/* Auth get the value sent from the AuthContext.Provider */}
            <SubmitBtnContext.Provider
              value={{
                loading: styledSubmitBtnState.loading,
                success: styledSubmitBtnState.success,
                dispatch
              }}
            >
              <NotificationContext.Provider
                value={{ get: getNotificationState.get, getNotiDispatch }}
              >
                <BrowserRouter>
                  <RouteChangeDetector />
                  <Switch>
                    <PrivateRoute
                      permissionName="service_management"
                      path="/service-management"
                      component={ServiceManagement}
                    />
                    <PrivateRoute
                      permissionName="No Permission"
                      path="/subscriptions/new"
                      component={Subscriptions}
                    />
                    <PrivateRoute
                      permissionName="No Permission"
                      path="/subscriptions"
                      component={Subscriptions}
                    />
                    <PrivateRoute
                      permissionName="No Permission"
                      path="/subscribe-new-service/:id"
                      component={SubscribeNewService}
                    />
                    <PrivateRoute
                      permissionName="No Permission"
                      path="/subscribe-new-service"
                      component={SubscribeNewService}
                    />
                    <PrivateRoute
                      permissionName="Account Center"
                      path="/account-center"
                      component={AccountCenter}
                    />
                    <PrivateRoute
                      permissionName="Access Management"
                      path="/access-management"
                      component={AccessManagement}
                    />
                    <PrivateRoute
                      permissionName="merchant_account_group_mapping"
                      path="/user-management"
                      useCommonLayout={true}
                      component={GroupsUsers}
                    />
                    <PrivateRoute
                      permissionName="merchant_managemant"
                      path="/store-management"
                      useCommonLayout={true}
                      component={StoreManagement}
                    />
                    <PrivateRoute
                      permissionName="Access Management"
                      path="/permission-management/:role_name/:role_id/:company_id?"
                      component={PermissionManagement}
                    />
                    <PrivateRoute
                      permissionName="Devices & Groups"
                      path="/devices-groups"
                      component={DevicesGroups}
                    />
                    <PrivateRoute
                      permissionName="Devices & Groups"
                      path="/company-device"
                      component={CompanyDevice}
                      hideFooter={true}
                    />
                    <PrivateRoute
                      permissionName="Account Center"
                      path="/company-profile/:company_id"
                      component={CompanyProfile}
                    />
                    <PrivateRoute path="/announcement" component={Announcement} />
                    <PrivateRoute
                      path="/create-announcement/:announcementId?/:type?"
                      component={CreateAnnouncement}
                    />
                    <PrivateRoute
                      path="/create-term/:termId?/:type?"
                      component={CreateTerm}
                    />
                    <PrivateRoute path="/personalized-management" component={PersonalizedManagement} />
                    <PrivateRoute
                      permissionName="No Permission"
                      path="/no-permission"
                      component={NoPermission}
                    />
                    <Route path="/login-error" component={LoginErrorPage}></Route>
                    <Route path="/forgotPassword" component={ForgotPassword} />
                    <Route path="/loginAgain" component={LoginAgain} />
                    <Route path="/login" component={casLogin} />
                    <PrivateRoute
                      permissionName="Home"
                      path="/"
                      component={Home}
                      exact
                    />
                    <PrivateRoute
                      path="/verify-email"
                      component={VerifyEmail}
                      showToolBar={false}
                      exact
                    />
                  </Switch>
                </BrowserRouter>
              </NotificationContext.Provider>
            </SubmitBtnContext.Provider>
          </LanguageProvider>
        </GlobalProvider>
      </Auth>
    </Suspense>
  );
}

export default App;
